export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.f74ba4e9.woff";